import React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import { useField } from 'formik';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';

function SelectMenu({ label, name, options, variant, valueKey, returnValue = "object", onChange,}) {
  const [field, meta, helpers] = useField(name);

  return (
    <>
      <FormControl fullWidth error = {Boolean(meta.error) && meta.touched}>
        { label && (
          <InputLabel variant='filled' id={name}>
            {label}
          </InputLabel>
        )}
        <Select
          {...field}
          name={name}
          labelId={name}
          id={name}
          fullWidth
          variant={variant ? variant : 'filled'}
          onBlur={() => helpers.setTouched(true)}
          onChange={(e) => {
          const selectedValue = e.target.value;
          if (returnValue === "id") 
          {
            helpers.setValue(selectedValue); 
          } 
          else 
          {
            helpers.setValue(
              options?.data?.find(
                (opt) => (opt.id || opt.code) === selectedValue
              ) || selectedValue
            );
          }

        if (typeof onChange === 'function') {
            onChange(e);
          }
        }}
      >
          {(options?.data || []).map((option) => (
              <MenuItem key={option.id || option.code} value={returnValue === "id" ? option.id || option.code : option}>
              {option.description || option.name || option.group_name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText variant='filled' error >{Boolean(meta.error) && meta.touched ? meta.error : ''}</FormHelperText>
      </FormControl>
    </>
  );
}

SelectMenu.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  variant: PropTypes.string,
  options: PropTypes.object,
  valueKey: PropTypes.string,
  returnValue: PropTypes.string,
  onChange: PropTypes.func,
};
export default SelectMenu;
